import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { X } from "lucide-react";
import { toast } from "sonner";

const ROOMS = ["Living Room", "Bedroom", "Dining", "Study", "Kids", "Other"];

export default function LeadPopup() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", room_of_interest: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const shown = sessionStorage.getItem("teak_lead_shown");
    if (shown) return;
    const t = setTimeout(() => setOpen(true), 30000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem("teak_lead_shown", "1");
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) return;
    setBusy(true);
    try {
      await axios.post(`${API}/leads`, { ...form, source: "popup" });
      toast.success("Thank you. Our concierge will reach out.");
      close();
    } catch {
      toast.error("Could not save. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-6 bg-black/70 fade-in" data-testid="lead-popup">
      <div className="relative w-full max-w-md p-10" style={{ background: "#141414", border: "1px solid var(--hairline)" }}>
        <button onClick={close} className="absolute top-4 right-4 text-[#8A8680] hover:text-[#EDE4D3] transition-colors duration-500" data-testid="lead-popup-close">
          <X size={18} strokeWidth={1} />
        </button>
        <div className="font-micro text-[#B8895C] mb-4">A Note From The Studio</div>
        <div className="font-serif text-[#EDE4D3] text-3xl leading-tight mb-3">Crafted for the way you live.</div>
        <p className="text-[#8A8680] text-sm mb-8 leading-relaxed">
          Leave us your details and a room in mind. A studio consultant will curate three pieces for you — no obligation.
        </p>
        <form onSubmit={submit} className="space-y-5">
          <input className="input-teak" placeholder="Full name" value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required data-testid="lead-name" />
          <input className="input-teak" placeholder="Phone" value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            required data-testid="lead-phone" />
          <div>
            <div className="font-micro text-[#8A8680] mb-3">Room of interest</div>
            <div className="flex flex-wrap gap-2">
              {ROOMS.map((r) => (
                <button type="button" key={r}
                  onClick={() => setForm({ ...form, room_of_interest: r })}
                  className={`chip ${form.room_of_interest === r ? "active" : ""}`}
                  data-testid={`lead-room-${r.toLowerCase().replace(/\s+/g, "-")}`}>{r}</button>
              ))}
            </div>
          </div>
          <button type="submit" className="btn-bronze w-full mt-4" disabled={busy} data-testid="lead-submit">
            {busy ? "Sending…" : "Send to concierge"}
          </button>
        </form>
      </div>
    </div>
  );
}
